import apiClient from "./apiClient"

const apiExpenseManagement = {

  uploadMultiple: async (formData, token) => {
    return apiClient.post(`/api/acc_control/uploadmultiple`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  getBatch: async (batchId) => {
    return apiClient.get(`/api/acc_control/get_batch/${batchId}`);
  },

  getBatches: async () => {
    return apiClient.get(`/api/acc_control/get_batches`);
  },

  getBatchFiles: async (batchId) => {
    return apiClient.get(`/api/acc_control/get_batch_files/${batchId}`);
  },
  deleteBatch: async (batchId) => {
    return apiClient.delete(`/api/acc_control/delete_batch/${batchId}`);
  },
  deleteFileBatch: async (batchId, fileId) => {
    return apiClient.delete(`/api/acc_control/delete_file/${fileId}/${batchId}`);
  },
};

export default apiExpenseManagement;
